import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import Parse from 'parse'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        name: 'home',
        auth: true
      }
    },

    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        name: 'login',
        fullSize: true
      },
      beforeEnter: (to, from, next) => {
        if (Parse.User.current()) {
          next({ name: 'home' })
        } else {
          next()
        }
      }
    },

    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        name: 'register',
        fullSize: true
      },
      beforeEnter: (to, from, next) => {
        if (Parse.User.current()) {
          next({ name: 'home' })
        } else {
          next()
        }
      }
    },

    {
      path: '/message',
      name: 'message',
      component: () => import('./views/Message.vue'),
      meta: {
        name: 'message',
        auth: true
      }
    },
    {
      path: '/event',
      name: 'event',
      component: () => import('./views/Event.vue'),
      meta: {
        name: 'event',
        auth: true
      }
    },
    {
      path: '/event/:id',
      name: 'event-content',
      component: () => import('./views/Event/Content.vue'),
      meta: {
        name: 'eventContent',
        auth: true,
        nav: {
          back: true
        }
      }
    },
    {
      path: '/answer-sheet',
      name: 'answer-sheet',
      component: () => import('./views/AnswerSheet.vue'),
      meta: {
        name: 'answerSheet',
        auth: true
      }
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('./views/Map.vue'),
      meta: {
        name: 'map',
        auth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('./views/Settings.vue'),
      meta: {
        name: 'settings',
        auth: true
      }
    },
    {
      path: '/settings/login',
      name: 'settings-login',
      component: () => import('./views/Settings/Login.vue'),
      meta: {
        name: 'loginInfo',
        auth: true,
        nav: {
          back: true
        }
      }
    },
    {
      path: '/settings/user',
      name: 'settings-user',
      component: () => import('./views/Settings/User.vue'),
      meta: {
        name: 'commonInfo',
        auth: true,
        nav: {
          back: true
        }
      }
    },
    {
      path: '/settings/bank',
      name: 'settings-bank',
      component: () => import('./views/Settings/Bank.vue'),
      meta: {
        name: 'bankInfo',
        auth: true,
        nav: {
          back: true
        }
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Parse.User.logOut()
  if (to.matched.some(r => r.meta.auth && !Parse.User.current())) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
